var map = {
	"./common.json": "9ea9",
	"./contact.json": "2fa7",
	"./footer.json": "9a53",
	"./form.json": "ccc3",
	"./formPayment.json": "eeb8",
	"./header.json": "bf45b",
	"./informPayment.json": "14ab",
	"./managePage.json": "9b8a",
	"./onlinePayment.json": "d08d",
	"./orderTracking.json": "e2de",
	"./pageBlog.json": "473b",
	"./pageContact.json": "36e8",
	"./pageEventCalendar.json": "0e5b",
	"./pageFormPayment.json": "7d45",
	"./pageGiftcard.json": "401f",
	"./pageInformPayment.json": "9edf",
	"./pageOnlinePayment.json": "7848",
	"./pagePayment.json": "2322",
	"./pageProduct.json": "215d",
	"./pageQuotationForm.json": "097c",
	"./paymentType.json": "fbd8",
	"./productReview.json": "f394",
	"./widgetCoupon.json": "6c7a",
	"./widgetEventCalendar.json": "a58c",
	"./widgetGiftcard.json": "2653",
	"./widgetInstagram.json": "4dad",
	"./widgetProduct.json": "1615",
	"./widgetProductCategory.json": "4f6c",
	"./widgetQuotationForm.json": "73e8",
	"./widgetSubscribe.json": "e33b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "777b";